exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".packages .nothing-found {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  margin: 40px;\n}\n.packages .premium {\n  border-radius: 9999px;\n  color: #085FCE;\n  background-color: transparent;\n  padding-right: 12px;\n  padding-left: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n}\n.packages .logo {\n  height: 22px;\n  width: auto;\n}", ""]);

// exports
